<div ng-controller="decryptUserController as ctrl" class="modal-view decrypt-user">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>